import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { timer } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-temoignages',
  templateUrl: './temoignages.component.html',
  styleUrls: ['./temoignages.component.scss']
})
export class TemoignagesComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  private subTimeout = null;

  public currentLang: string;

  private temoignagesCourant;
  private nbTemoignages;
  private listeTemoignages;
  public get temoignage(): { texte: string, personne: string, image: string } {
    return this.listeTemoignages[this.temoignagesCourant];
  }

  constructor(private route: ActivatedRoute, private elementRef: ElementRef, private translateService: TranslateService ) {
    this.currentLang = this.translateService.currentLang;
    this.temoignagesCourant = 0;
    this.listeTemoignages = this.route.snapshot.data.temoignages;
    this.nbTemoignages = this.listeTemoignages.length || 0;
    this.ngUnsubscribe = new Subject<void>();
  }

  ngOnInit() {
    this.AjouteClassEnLot('[data-animated]', 'animated-out');
    this.rollTemoignages();

    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang
    });
  }

  ngOnDestroy() {
    this.subTimeout.unsubscribe();
  }

  private AjouteClassEnLot(item, classe) {
    Array.from<HTMLElement>(this.elementRef.nativeElement.querySelectorAll(item)).forEach((userItem) => {
      userItem.classList.add(classe);
    });

  }

  private rollTemoignages() {
    this.subTimeout = timer(0, 5000).subscribe(() => {
      this.temoignagesCourant++;
      this.temoignagesCourant %= this.nbTemoignages;
    }, error => {this.nbTemoignages = 0; });
  }

}
